module.exports = __webpack_public_path__ + "static/media/lq.909ea937.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/activity/lq.png
// module id = 728
// module chunks = 0